export enum AdjustmentType {
    ADDITION,
    SUBTRACTION
}